import React from "react";
import ModalComponent from "../../../Components/ModalComponent";
import { Button, Col, Form, Row } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import { toApplyJob } from "../../../apis/actions/job.actions";
import { convertFileToBase64, showNotitfication } from "../../../utils/Utils";
import UploadInput from "../../../Components/biblio/UploadFileInput";
import { BiUpload } from "react-icons/bi";
import { useTranslation } from "react-i18next";

interface ApplyJobProps {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  selectedData: any;
}

const ApplyJob = ({ showModal, setShowModal, selectedData }: ApplyJobProps) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();

  const { loading } = useSelector((state: RootState) => state.jobs.jobApply);

  const handleFileChange = async (fileList: any[]) => {
    const file = fileList[0]?.originFileObj;

    if (file) {
      try {
        const base64 = await convertFileToBase64(file);
        const imageData = {
          filename: file.name,
          data: base64,
        };

        form.setFieldsValue({
          attachment_ids: [imageData],
        });
      } catch (error) {
        console.error("Error converting file to Base64:", error);
      }
    }
  };

  const handleApply = async () => {
    try {
      await form.validateFields();
      const values = form.getFieldsValue();
      const applyData = {
        ...values,
        job_id: selectedData.id,
      };

      const success = (await dispatch(toApplyJob(applyData))) as any;
      const jobs = success?.payload?.data?.result;

      if (jobs?.code === 200) {
        showNotitfication(jobs?.message, "success");
        form.resetFields();
        setTimeout(() => {
          setShowModal(false);
        }, 2800);
      } else {
        showNotitfication(jobs?.message, "error");
      }
    } catch (error) {}
  };

  return (
    <ModalComponent
      title={
        <div className="ac--order-details-header">
          <span className="text-md-bold ac--color-text-profile">
            {t("jobs.apply")} {selectedData?.name}
          </span>
        </div>
      }
      open={showModal}
      onClose={() => setShowModal(false)}
      closeOnOutsideClick={true}
      width={500}
    >
      <Form form={form} layout="vertical" className="mt-20">
        <Row gutter={16}>
          <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              label={t("register.fullname")}
              name="partner_name"
              rules={[
                { required: true, message: "Please input your full name!" },
              ]}
              labelCol={{ className: "text-md-bold" }}
            >
              <input type="text" className="ac--input" />
            </Form.Item>
          </Col>

          <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              label={t("profile.account.email")}
              name="email_from"
              rules={[
                { required: true, message: "Please input your email!" },
                { type: "email", message: "Please input a valid email!" },
              ]}
              labelCol={{ className: "text-md-bold" }}
            >
              <input type="email" className="ac--input" />
            </Form.Item>
          </Col>

          <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              label={t("profile.account.phone")}
              name="partner_mobile"
              rules={[{ required: true, message: "Please input your mobile!" }]}
              labelCol={{ className: "text-md-bold" }}
            >
              <input type="number" className="ac--input" />
            </Form.Item>
          </Col>

          <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="attachment_ids"
              label={t("jobs.attachement")}
              rules={[
                {
                  required: true,
                  message: "Please upload your Cv!",
                },
              ]}
              labelCol={{ className: "text-md-bold" }}
            >
              <UploadInput
                accept="*"
                text="Attach your CV"
                icon={<BiUpload size={15} />}
                multiple={false}
                maxCount={1}
                onChange={handleFileChange}
              />
            </Form.Item>
          </Col>

          <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
            <Form.Item
              label={t("register.more")}
              name="description"
              rules={[{ required: true, message: "Please input your mobile!" }]}
              labelCol={{ className: "text-md-bold" }}
            >
              <textarea rows={2} className="ac--input" />
            </Form.Item>
          </Col>
        </Row>
        <Row className="mt-20" justify="end">
          <Button
            className="text-md ac--btn-edit-save"
            onClick={handleApply}
            disabled={loading === true}
          >
            {loading === true ? t("btn.loading") : t("btn.send")}
          </Button>
        </Row>
      </Form>
    </ModalComponent>
  );
};

export default ApplyJob;
